export const allowedFileTypes = [
  '.csv',
  '.doc',
  '.docx',
  '.eml',
  '.fax',
  '.htm',
  '.html',
  '.img',
  '.jpeg',
  '.jpg',
  '.json',
  '.mht',
  '.mhtml',
  '.msg',
  '.pdf',
  '.png',
  '.ppt',
  '.pptx',
  '.rtf',
  '.tif',
  '.txt',
  '.xls',
  '.xlsx',
  '.zip',
  '.xlsm',
];
